import { useRef, useState } from "react";
import { ImagePlus, Crop, RefreshCw, Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, bgStyle, errMsg } from "@/lib/api";
import { FocusDialog } from "@/components/studio/FocusDialog";

export const SlotTile = ({ collectionId, slot, panel, photo, onUpsert, onRemove }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const [focusOpen, setFocusOpen] = useState(false);
  const id = `${collectionId}-${slot}`;
  const aspect = panel.w / panel.h;

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("collection", collectionId); fd.append("slot", slot); fd.append("file", file);
    try {
      const { data } = await api.post("/photos", fd);
      onUpsert(data);
      toast.success(`Foto añadida a la placa ${panel.name.toLowerCase()}`);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
    input.current.value = "";
  };

  const remove = async () => {
    try { await api.delete(`/photos/${photo.id}`); onRemove(photo.id); } catch (e) { toast.error(errMsg(e)); }
  };

  const iconBtn = "grid h-8 w-8 place-items-center rounded-full bg-white/90 text-[#1C1715] shadow-sm hover:bg-[#C5A059] transition-colors";

  return (
    <div data-testid={`slot-${id}`}>
      <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" hidden data-testid={`slot-${id}-file-input`} onChange={(e) => upload(e.target.files[0])} />
      <div className="group relative overflow-hidden rounded-[3px] bg-[#F4EFE6]" style={{ aspectRatio: aspect }}>
        {photo ? (
          <>
            <div data-testid={`slot-${id}-image`} className="absolute inset-0" style={bgStyle(photo, aspect)} />
            <div className="absolute inset-0 flex items-end justify-end gap-1.5 p-2 opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity">
              <button title="Ajustar encuadre" data-testid={`slot-${id}-focus-button`} className={iconBtn} onClick={() => setFocusOpen(true)}><Crop className="h-3.5 w-3.5" /></button>
              <button title="Reemplazar" data-testid={`slot-${id}-replace-button`} className={iconBtn} onClick={() => input.current.click()}><RefreshCw className="h-3.5 w-3.5" /></button>
              <button title="Quitar" data-testid={`slot-${id}-remove-button`} className={iconBtn} onClick={remove}><Trash2 className="h-3.5 w-3.5" /></button>
            </div>
          </>
        ) : (
          <button data-testid={`slot-${id}-upload-button`} onClick={() => input.current.click()}
            className="absolute inset-0 flex flex-col items-center justify-center gap-2 border border-dashed border-[#1C1715]/20 text-[#8C827A] hover:border-[#C5A059] hover:text-[#A67C52] transition-colors">
            <ImagePlus className="h-5 w-5" />
            <span className="text-[0.65rem] uppercase tracking-[0.18em]">Subir</span>
          </button>
        )}
        {busy && <div className="absolute inset-0 grid place-items-center bg-white/70"><Loader2 className="h-5 w-5 animate-spin text-[#A67C52]" /></div>}
      </div>
      <p className="mt-2 text-[0.7rem] text-[#1C1715]">{panel.name}</p>
      <p className="text-[0.65rem] text-[#8C827A]">{panel.dim}</p>
      {photo && <FocusDialog open={focusOpen} onOpenChange={setFocusOpen} photo={photo} aspect={aspect} onSaved={onUpsert} testId={id} />}
    </div>
  );
};
